<h2 mat-dialog-title class="dialog-header">{{ getDialogTitle() }}</h2>

<div mat-dialog-content>
  <!-- Add New Mode -->
  @if (currentMode === 'add-new') {
    <div class="create-form-content">
      <app-large-shareholder-form
        [form]="createForm"
        [isEditMode]="false"
        [hideActions]="true"
        (submit)="onCreateSubmit()">
      </app-large-shareholder-form>
    </div>
  }

  <!-- Edit Mode -->
  @if (currentMode === 'edit') {
    <div class="create-form-content">
      <app-large-shareholder-form
        [form]="editForm"
        [isEditMode]="false"
        [hideActions]="true"
        (submit)="onEditSubmit()">
      </app-large-shareholder-form>
    </div>
  }

  <!-- Search & Connect Mode (hidden instead of removed to preserve results) -->
  <div [hidden]="currentMode !== 'search-connect'">
    <ngx-spinner type="ball-atom"></ngx-spinner>
    <app-add-shareholder-search
      (shareholderSelected)="onShareholderSelected($event)"
      (addNewRequested)="onAddNewFromSearch()"
      (editRequested)="onEditShareholder($event)">
    </app-add-shareholder-search>
  </div>
</div>

<div mat-dialog-actions class="dialog-actions">
  @if (currentMode === 'search-connect') {
    <button mat-raised-button color="primary" type="button" (click)="onAddNewFromSearch()">
      <mat-icon>person_add</mat-icon>
      Create New Large Shareholder
    </button>
  }
  @if (currentMode === 'add-new' || currentMode === 'edit') {
    <button mat-flat-button type="button" (click)="onBack()">
      <mat-icon>arrow_back</mat-icon>
      Back to Search
    </button>
  }
  <span class="spacer"></span>
  <button mat-flat-button type="button" class="nrg-error-flat-button" (click)="onCancel()">
    <mat-icon>clear</mat-icon>
    Cancel
  </button>
  @if (currentMode === 'add-new') {
    <button mat-flat-button color="primary" (click)="onCreateSubmit()"
            [disabled]="!createForm.valid">
      <mat-icon>save</mat-icon>
      Create Large Shareholder
    </button>
  }
  @if (currentMode === 'edit') {
    <button mat-flat-button color="primary" (click)="onEditSubmit()"
            [disabled]="!editForm.valid || !editForm.dirty">
      <mat-icon>save</mat-icon>
      Save Changes
    </button>
  }
  @if (currentMode === 'search-connect') {
    <button mat-flat-button color="primary" (click)="onConfirmConnect()"
            [disabled]="!selectedItem">
      <mat-icon>person_add</mat-icon>
      Add Shareholder
    </button>
  }
</div>
